angular.module("vgresiduos").directive("destinationFollowupDetails", function () {
	return {
		scope: true,
		controller: "DestinationFollowupDetailsCtrl",
		controllerAs: "ctrl",
		templateUrl: "views/destination/followup/followupDetails/destinationFollowupDetails_template.html",
		bindToController: {
			model: "="
		}
	};
});
